module.exports = __webpack_public_path__ + "media/images/homepage_image_1-65de475acc3505d5b9640eba7059029c.png";